export default __webpack_public_path__ + "locales/nl/SendInviteDialog.json?hash=5d49c5aa40c98ebd99e21f05ef16fdab";